// LocalStorage keys
export const STORAGE_KEYS = {
  FOLDERS: 'mi_bondi_folders',
  STOPS: 'mi_bondi_stops'
};

/**
 * Obtener todas las carpetas del localStorage
 */
export const getFolders = () => {
  try {
    const data = localStorage.getItem(STORAGE_KEYS.FOLDERS);
    return data ? JSON.parse(data) : [];
  } catch (error) {
    console.error('Error al obtener carpetas:', error);
    return [];
  }
};

/**
 * Guardar carpetas en localStorage
 */
export const saveFolders = (folders) => {
  try {
    localStorage.setItem(STORAGE_KEYS.FOLDERS, JSON.stringify(folders));
  } catch (error) {
    console.error('Error al guardar carpetas:', error);
  }
};

/**
 * Obtener todas las paradas del localStorage
 */
export const getStops = () => {
  try {
    const data = localStorage.getItem(STORAGE_KEYS.STOPS);
    return data ? JSON.parse(data) : [];
  } catch (error) {
    console.error('Error al obtener paradas:', error);
    return [];
  }
};

/**
 * Guardar paradas en localStorage
 */
export const saveStops = (stops) => {
  try {
    localStorage.setItem(STORAGE_KEYS.STOPS, JSON.stringify(stops));
  } catch (error) {
    console.error('Error al guardar paradas:', error);
  }
};

/**
 * Crear una nueva carpeta
 */
export const createFolder = (name, color = '#3B82F6') => {
  const folders = getFolders();
  const newFolder = {
    id: Date.now().toString(),
    name,
    color,
    createdAt: new Date().toISOString(),
    stopCount: 0
  };
  folders.push(newFolder);
  saveFolders(folders);
  return newFolder;
};

/**
 * Eliminar una carpeta
 */
export const deleteFolder = (folderId) => {
  const folders = getFolders();
  const filtered = folders.filter(f => f.id !== folderId);
  saveFolders(filtered);
  
  // También eliminar paradas de esa carpeta
  const stops = getStops();
  const stopsFiltered = stops.filter(s => s.folderId !== folderId);
  saveStops(stopsFiltered);
};



/**
 * Agregar parada a una carpeta
 */
export const addStopToFolder = (folderId, stopId, stopName, line) => {
  const stops = getStops();
  const newStop = {
    id: Date.now().toString(),
    stopId,
    stopName,
    folderId,
    line: line || null,
    createdAt: new Date().toISOString()
  };
  stops.push(newStop);
  saveStops(stops);
  
  // Actualizar conteo de paradas en la carpeta
  updateFolderStopCount(folderId);
  
  return newStop;
};

/**
 * Eliminar parada
 */
export const deleteStop = (stopId) => {
  const stops = getStops();
  const stop = stops.find(s => s.id === stopId);
  const filtered = stops.filter(s => s.id !== stopId);
  saveStops(filtered);
  
  // Actualizar conteo
  if (stop) {
    updateFolderStopCount(stop.folderId);
  }
};

/**
 * Obtener paradas de una carpeta
 */
export const getStopsByFolder = (folderId) => {
  const stops = getStops();
  return stops.filter(s => s.folderId === folderId);
};

/**
 * Actualizar conteo de paradas en carpeta
 */
export const updateFolderStopCount = (folderId) => {
  const folders = getFolders();
  const folder = folders.find(f => f.id === folderId);
  if (folder) {
    const stopCount = getStopsByFolder(folderId).length;
    folder.stopCount = stopCount;
    saveFolders(folders);
  }
};

/**
 * Obtener carpeta por ID
 */
export const getFolderById = (folderId) => {
  const folders = getFolders();
  return folders.find(f => f.id === folderId);
};

/**
 * Obtener parada por stopId
 */
export const getStopByStopId = (stopId) => {
  const stops = getStops();
  return stops.find(s => s.stopId === stopId);
};
